{ "imageTag": "20261105102532_503ff3d", "buildUri": "vstfs:///Build/Build/104352", "buildId": "104352", "sourceCommit": "503ff3d51da2f6f74a53307e576555ed97af7d95", "sourceBranch": "main", "releaseDate": "2026-11-05T10:27:57Z" }
